import { render, staticRenderFns } from "./Similar.vue?vue&type=template&id=0db7a40e&scoped=true&"
import script from "./Similar.vue?vue&type=script&lang=js&"
export * from "./Similar.vue?vue&type=script&lang=js&"
import style0 from "./Similar.vue?vue&type=style&index=0&id=0db7a40e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7a40e",
  null
  
)

export default component.exports